import { useMediaQuery, useTheme } from "@mui/material";
import PageLoader from "components/PageLoader";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DashboardRoutes } from "routes/DashboardRoutes";
import useStore from "store";
import Appbar from "./components/Appbar";
import Sidebar from "./components/Sidebar";
import classes from "./style.module.scss";

const DashboardLayout = () => {
  const location = useLocation();
  const history = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { sidebarOpenStore, accessTokenStore, storeLogout, isLoadingStore } = useStore();

  const [appbarTitle, setAppbarTitle] = useState("");

  useEffect(() => {
    if (!accessTokenStore) {
      storeLogout();
      history("/oauth");
    } else {
      const selectedRoute = DashboardRoutes.find(
        (route) => location.pathname === `/dashboard${route?.path ? `/${route?.path}` : ""}`
      );
      if (selectedRoute) {
        setAppbarTitle(selectedRoute?.title);
      }
    }
  }, [history]);

  return (
    <>
      <PageLoader isLoading={isLoadingStore} />
      <div className={classes.container}>
        <Sidebar />
        <div
          className={`${classes.wrapper} ${
            isMobile ? classes.wrapperFull : !sidebarOpenStore ? classes.wrapperFull : ""
          }`}
        >
          <Appbar title={appbarTitle} />
          <div className={classes.page}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
